<template>
    <div class="user-list">
        <template v-for="(attendee, attendee_i) in agenda.agenda_registered_attendee" >
            <b-card
                v-if="isActivity || (attendee.status != 2 && agenda.agenda_user_guestlist_bool)"
                :key="attendee_i"
                tag="article" class="mb-2 user-list-item">
                    <user-list-item
                        :attendee="attendee" 
                        :user_name="attendee.name" 
                        :user_id="attendee.ID" 
                        :agenda_hash="agenda.agenda_hash" 
                        :count_guest="attendee.count_guest" 
                        :count_spouse="attendee.count_spouse"
                        :thumbnail="attendee.thumbnail"
                        :hideDetailButton="hideDetailButton"
                    ></user-list-item>
            </b-card>
        </template>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import UserListItemVue from './UserListItem.vue';
export default {
    name: 'user-list',
    components: {
        'user-list-item': UserListItemVue
    },
    computed: { 
        ...mapGetters('auth', ['isActivity']),
        isAdmin() {
            return true;
        }
    },
    props: {
        agenda: {
            type: Object
        },
        expandable: {
            type: Boolean
        },
        hideDetailButton: {
            type: Boolean,
            default: false
        }
    }
}
</script>